module.exports = __webpack_public_path__ + "static/fortheking-e76a655f9fbf417fd7b951bfb5384fce.png";